import { Routes } from '../constants';

/**
 * Formats the provided url by stripping the protocal.
 * @param {String} url The url to format.
 * @returns String
 */
export function formatUrlWithoutProtocol(url) {
  return url.startsWith('http') || url.startsWith('https') || url.startsWith('//') ? url : `//${url}`;
}

/**
 * 
 * @param {*} config 
 * @param {*} route 
 * @returns 
 */
export function generateRoute(config, route) {
  let newRoute = '';
  const defaultRoutes = {
    home: Routes.home,
    result: Routes.results,
    practice: Routes.details,
    tabliteBooking: Routes.tabliteBooking
  };
  const { custom_routing } = config;

  if (custom_routing) {
    if (custom_routing[route]) {
      newRoute = custom_routing[route];
    }
    else {
      newRoute = defaultRoutes[route];
    }
  }
  else {
    newRoute = defaultRoutes[route];

    if (!newRoute) {
      newRoute = '';
    }
  }

  return newRoute;
}
